<template>
  <form
    v-if="currentQuestion"
    class="testing-form"
  >
    <header class="form-head">
      <app-counter
        v-if="questions.length"
        :current="currentQuestion.id"
        :total="total"
      />
      <p class="form-head__title">
        На сколько тебе нравится?
      </p>
    </header>
    <transition
      name="fade"
      mode="out-in"
    >
      <div
        :key="currentQuestion.id"
        class="form-body"
      >
        <p class="form-body__question">{{ questions.length ? questions[currentIndex].question : '' }}</p>
        <app-radio-group
          v-if="answers.length"
          :key="currentQuestion.id"
          v-model.number="val"
          :levels="answers"
          :name="`answer-${currentIndex}`"
          item-text="answer"
          @changeRadioButton="clickButton()"
        />
      </div>
    </transition>

    <footer class="form-footer">
      <app-button
        class="form-footer__button"
        icon="IconLeftRow"
        icon-position="left"
        type="button"
        @click.native="getPreviousQuestion"
      >
        Назад
      </app-button>
    </footer>
  </form>
</template>

<script>
import AppButton from '../Base/AppButton';
import AppCounter from './AppCounter';
import AppRadioGroup from './AppRadioGroup';

export default {
  name: 'TestingForm',
  components: {
    AppButton,
    AppCounter,
    AppRadioGroup,
  },
  data() {
    return {
      currentIndex: 0,
      total: 0,
      questions: [],
      answers: [],
      val: '',
      lastUserAnswer: 0,
      show: true,
    };
  },
  computed: {
    currentQuestion() {
      return this.questions[this.currentIndex];
    },
  },
  watch: {
    currentIndex(val) {
      this.val = '';
      localStorage.setItem('lastCurrent', val);
    },
  },
  async created() {
    if (localStorage.user_id === undefined || localStorage.user_id === null) {
      return this.$router.push('/');
    }
    try {
      const response = await this.$axios.get('/questions');
      this.total = response.data.length;
      this.questions = response.data.sort((a, b) => a.id - b.id);
    } catch (error) {
      console.log(error);
    }
    try {
      const { data } = await this.$axios.get('/answers');
      data.sort((prev, next) => next.id - prev.id);
      this.answers = data;
    } catch (error) {
      console.log(error);
    }
    const current = Number(localStorage.getItem('lastCurrent'));
    this.currentIndex = current !== undefined ? current : 0;
  },
  methods: {
    async clickButton() {
      if (this.lastUserAnswer === 0) {
        await this.setResult();
      } else {
        await this.update();
      }
    },
    async update() {
      const config = {
        answer_id: this.val,
      };
      try {
        await this.$axios.patch(`/results/${this.lastUserAnswer.id}`, config);
        this.currentIndex += 1;
        this.lastUserAnswer = 0;
      } catch (error) {
        console.log(error);
      }
    },
    // Проверка на существование записи в БД
    async setResult() {
      const params = {
        user_id: Number(localStorage.getItem('user_id')),
        question_id: this.currentQuestion.id,
      };
      try {
        const response = await this.$axios.get('/results', { params });
        if (response.data.length > 0) {
          const data = response.data[0];
          this.lastUserAnswer = data;
          return this.update();
        }
      } catch (error) {
        console.log(error);
      }
      // Добавление записи
      const parameters = {
        user_id: localStorage.getItem('user_id'),
        question_id: this.currentQuestion.id,
        answer_id: this.val,
      };
      try {
        await this.$axios.post('/results', parameters);
        if ((this.currentQuestion.id) !== this.total) {
          this.currentIndex += 1;
        } else {
          localStorage.setItem('lastCurrent', 0);
          try {
            const crmParameters = {
              user_id: localStorage.getItem('user_id'),
              url: window.location.hostname,
              gaCid: localStorage.getItem('ga_cid'),
            };
            this.$axios.post('/sending', crmParameters);
          } catch (error) {
            console.log(error);
          }
          return this.$router.push('/finish');
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getPreviousQuestion() {
      if (this.currentIndex === 0) {
        // eslint-disable-next-line no-alert
        return alert('Это первый вопрос');
      }
      // Запрос записи из БД при возврате назад
      try {
        this.currentIndex -= 1;
        const params = {
          user_id: Number(localStorage.getItem('user_id')),
          question_id: this.currentQuestion.id,
        };
        const response = await this.$axios.get('/results', { params });
        const data = response.data[0];
        this.lastUserAnswer = data;
        this.val = data.answer_id;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
    opacity: 0;
  }
  .error {
    padding: 10px;
    color: rgb(212, 0, 0);
    font-weight: bold;
  }
  .testing-form {
    padding: 24px;
    width: 450px;
    background: #FFFFFF;
    border: 1px solid #DBDBDB;
    box-sizing: border-box;
    box-shadow: 0 4px 14px rgba(70, 97, 138, 0.2);
    border-radius: 8px;
  }
  .form-head {
    width: 100%;
    font-weight: bold;
    font-size: 23px;
    display: flex;
    justify-content: space-evenly;
    &__title {
      font-size: 23px;
      margin: 0;
    }
  }
  .form-body {
    padding: 24px 0;
    margin: 24px 0;
    border-top: 1px rgb(200, 200, 200) solid;
    border-bottom: 1px rgb(200, 200, 200) solid;
    &__question {
      height: 80px;
      font-size: 16px;
      margin: 0;
    }
    &__list {
      list-style-type: none;
      padding: 0;
    }
  }
  .form-footer {
    display: flex;
    justify-content: space-between;
  }
  @media screen and (max-width: 576px){
    .testing-form {
      width: 288px;
      .form-head {
        flex-direction: column;
      }
    }
    .form-body {
      &__question {
        height: 110px;
      }
    }
  }
</style>
